export default __webpack_public_path__ + "static/media/6312385.ccf67fe0.jpeg";